export default "__VITE_ASSET__B0v8kUZg__"